
import { postBiz } from './activityPlanningApi';

export type ComboRow = { rid: number; shc: string; nam: string; [key: string]: any };

const rows = (json: any): ComboRow[] => {
  const sd = json.sd || json.result?.sd || json.data?.sd || json;
  return Array.isArray(sd) ? sd : [];
};

export const fetchGlobalObjectiveCombo = async (axc = '') =>
  rows(await postBiz({ s: 'globalobjective', a: 'combo', axc: axc || null }));

export const fetchSpecificObjectiveCombo = async (axc = '', ogc = '') =>
  rows(await postBiz({ s: 'specificobjective', a: 'combo', axc: axc || null, ogc: ogc || null }));
